import { Country } from '@xemplo/country-helper';

import { tryParsePhoneNumber } from './phone-field.helper';

/**
 * Simple validation to check if a phone number is valid for a given country.
 * Providing a Country.Code is required to ensure accurate validation.
 * It prevent the ambiguity of phone country codes that are shared across multiple countries.
 * e.g.: +1 is used by the US, Canada, and several Caribbean nations.
 *
 * @param value
 * @param countryCode
 * @returns
 */
export function isValidPhone(value: string, countryCode: Country.Code): boolean {
  const phoneNumber = tryParsePhoneNumber(value, countryCode);
  return phoneNumber?.isValid() ?? false;
}
